import React, { useState } from 'react';
import styles from './bomListTable.module.css';
import { Close, Downarrow, EditPart, Leaf, Pdf, Refresh, trash, Uparrow } from '../../../Svg';
import { deleteAlterProduct, getAlterProductsThunk } from '../../../redux/bomSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { formateDate, stripHtmlTags } from '../../../utils/fomateDate';

const BomListTable = ({ products, handleSelectAlternate, show, editingProduct, newPartNumber, setNewPartNumber, handleSubmit, handleEditClick, enquiryType, selectable = false, selectedProducts = [], onToggleSelect, onToggleSelectAll }) => {
    // Wizard and Excess quotes show unmatched parts on light rows instead of black ones
    const isWizardQuote = enquiryType === 'WIZARD' || enquiryType === 'excess';
    const allSelected = selectable && products?.length > 0 && products.every((p) => selectedProducts.includes(p?.productNumber));
    const unmatchedRowStyle = { backgroundColor: isWizardQuote ? '#FFFFFF' : 'black' };
    const unmatchedTextStyle = { color: isWizardQuote ? '#667085' : 'white' };

    // Collect all unique keys for additional columns
    const [expandedProducts, setExpandedProducts] = useState({});
    const dispatch = useDispatch()
    const { alterLoading, alterProducts } = useSelector((state) => state.bom)
    const altProd = alterProducts?.alternateProducts || []
    const productnumber = alterProducts?.productnumber || []
    const navigate = useNavigate()

    const toggleShowAll = (productId) => {
        setExpandedProducts((prev) => ({
            ...prev,
            [productId]: !prev[productId],
        }));
    };

    const allAttributeKeys = Array.from(
        new Set(
            products?.flatMap((product) =>
                Object.keys(product?.product?.attributes || {})
            )
        )
    );

    const allEnvironmentalKeys = Array.from(
        new Set(
            products?.flatMap((product) =>
                Object.keys(product?.product?.environmental || {})
            )
        )
    );

    const allAdditionalResources = Array.from(
        new Set(
            products?.flatMap((product) =>
                Object.keys(product?.product?.additionalResources || {})
            )
        )
    );



    const altallAttributeKeys = Array.from(
        new Set(altProd?.flatMap(product => Object.keys(product?.attributes || {})))
    );


    const altallEnvironmentalKeys = Array.from(
        new Set(altProd?.flatMap(product => Object.keys(product?.environmental || {})))
    );

    const altallAdditionalResources = Array.from(
        new Set(altProd?.flatMap(product => Object.keys(product?.additionalResources || {})))
    );

    const searchAlter = (part) => {
        dispatch(getAlterProductsThunk(`?productNumber=${part}`))
    }


    console.log("products---", products)


    return (
        <div className={styles.sortedTable} >
            <div className={styles.productTableContainer}>
                <table className={styles.productTable}>
                    <thead className={styles.productTableHead}>
                        <tr style={{ height: 30 }}>
                            <th className={styles.compare}>
                                {selectable ?
                                    <label className={styles.selectCell}>
                                        <input
                                            type="checkbox"
                                            className={styles.selectCheckbox}
                                            checked={allSelected}
                                            onChange={(e) => onToggleSelectAll && onToggleSelectAll(e.target.checked)}
                                            aria-label="Select all products"
                                        />
                                        <span>All</span>
                                    </label>
                                    : 'Compare'}
                            </th>
                            {/* <th className={styles.dataSheet}>Data sheet</th> */}
                            <th className={styles.partNumber}>
                                <div className={styles.headerWithFilter}>
                                    <span>Part</span>
                                    <div className={styles.sortIcons}>
                                        <Uparrow />
                                        <Downarrow />
                                    </div>
                                </div>
                            </th>
                            <th className={styles.manufacturer}>
                                <div className={styles.headerWithFilter}>
                                    <span>Manufacturer</span>
                                    <div className={styles.sortIcons}>
                                        <Uparrow />
                                        <Downarrow />
                                    </div>
                                </div>
                            </th>
                            <th className={styles.stock}>
                                <div className={styles.headerWithFilter}>
                                    <span>Available Stock</span>
                                    <div className={styles.sortIcons}>
                                        <Uparrow />
                                        <Downarrow />
                                    </div>
                                </div>
                            </th>
                            <th className={styles.unitPrice}>Unit Price</th>
                            <th className={styles.requiredQuantity}>Required Quantity</th>
                            {
                                enquiryType == "WIZARD" &&
                                <th className={styles.requiredQuantity}>Required Price</th>
                            }

                            {
                                enquiryType === "excess" && <>
                                    <th className={styles.unitPrice}>Target price</th>
                                    <th className={styles.requiredQuantity}>Required Date</th>
                                </>
                            }
                            {/* {allAttributeKeys.map((key) => (
                                <th className={styles.packageType} key={key}>
                                    {key}
                                </th>
                            ))} */}
                            {/* {allEnvironmentalKeys.map((key) => (
                                <th className={styles.packageType} key={key}>
                                    {key}
                                </th>
                            ))} */}
                            {/* {allAdditionalResources.map((key) => (
                                <th className={styles.packageType} key={key}>
                                    {key}
                                </th>
                            ))} */}
                        </tr>
                    </thead>
                    <tbody>
                        {products?.map((product, index) => (

                            <>
                                <tr
                                    key={index}
                                    style={product?.status ? { backgroundColor: 'white' } : unmatchedRowStyle}
                                >
                                    <td className={`${styles.compare} ${styles.tdBorder}`}>
                                        {selectable ?
                                            <label className={styles.selectCell}>
                                                <input
                                                    type="checkbox"
                                                    className={styles.selectCheckbox}
                                                    checked={selectedProducts.includes(product?.productNumber)}
                                                    onChange={() => onToggleSelect && onToggleSelect(product?.productNumber)}
                                                    aria-label={`Select ${product?.productNumber}`}
                                                />
                                                <span>{index + 1}</span>
                                            </label>
                                            : index + 1}
                                    </td>
                                    {/* <td className={`${styles.dataSheet} ${styles.tdBorder}`}>
                                        {product?.status ? (
                                            <div className={styles.dataCol}>
                                                <Pdf />
                                                <Leaf />
                                            </div>
                                        ) : (
                                            <div style={unmatchedTextStyle}>-</div>
                                        )}
                                    </td> */}
                                    <td className={`${styles.partNumber} ${styles.tdBorder}`}>
                                        <div className={styles.dataRow}>
                                            {product?.status ? (
                                                <>
                                                    <img src={product?.product?.assets?.featuredImage[0]} style={{ width: 40, height: 40 }} />
                                                    <div className={styles.dataCol}>

                                                        {editingProduct === product.productNumber ?
                                                            <div style={{ display: 'flex' }}>
                                                                <input
                                                                    type="text"
                                                                    className={styles.dataInput}
                                                                    value={newPartNumber}
                                                                    onChange={(e) => setNewPartNumber(e.target.value)}
                                                                />

                                                                <button onClick={handleSubmit} className={styles.addButton}>Submit</button>

                                                            </div>
                                                            :
                                                            <div className={styles.displayFlex} >
                                                                <div className={styles.dataColorChange} style={{ cursor: 'pointer' }}>
                                                                    <a href={`https://electrowiz.in/productCode/${product?.product?._id}`} target='_blank'>
                                                                        {product?.productNumber}
                                                                    </a>
                                                                </div>
                                                                {!show &&
                                                                    <div onClick={() => handleEditClick(product?.productNumber)} style={{ cursor: 'pointer' }}>
                                                                        <EditPart />
                                                                    </div>
                                                                }
                                                            </div>
                                                        }

                                                        <div>
                                                            <a href={`https://electrowiz.in/productCode/${product?.product?._id}`} target='_blank'>
                                                                {stripHtmlTags(product?.product?.productOverview?.description?.[0] || product?.product?.description)}
                                                            </a>
                                                        </div>
                                                        {!show &&
                                                            <div style={{ display: 'flex', gap: 10 }}>
                                                                <div disabled={alterLoading} onClick={() => searchAlter(product?.productNumber)} style={{ textDecoration: 'underline', color: '#512DA8', cursor: 'pointer' }}>Search Alternate</div>
                                                                {alterLoading &&
                                                                    <div>
                                                                        <img src="/assets/__Iphone-spinner-1.gif" alt="" style={{ width: 25, height: 25 }} />
                                                                    </div>
                                                                }
                                                            </div>
                                                        }
                                                    </div>
                                                </>
                                            ) : (
                                                <div>
                                                    <div
                                                        style={{
                                                            background: 'white',
                                                            padding: '7px 40px 7px 10px',
                                                            color: '#000',
                                                            fontSize: 12,
                                                            fontWeight: 400,
                                                        }}
                                                    >
                                                        <a href={`https://electrowiz.in/productCode/${product?._id}`} target='_blank'>
                                                            {product?.productNumber}
                                                        </a>
                                                    </div>
                                                    <div
                                                        style={{
                                                            color: isWizardQuote ? '#667085' : '#FFFFFF',
                                                            fontSize: 14,
                                                            fontWeight: 400,
                                                            marginTop: 7,
                                                        }}
                                                    >
                                                        Exact match not found.
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </td>
                                    <td className={`${styles.manufacturer} ${styles.tdBorder}`}>
                                        {product?.status ? (
                                            <a href={product.manufacturerUrl} className={styles.manufacturer}>
                                                <div className={styles.dataColorChange}>
                                                    {product?.product?.productOverview?.manufacturer[0]?.name}
                                                </div>
                                            </a>
                                        ) : (
                                            <div style={unmatchedTextStyle}>-</div>
                                        )}
                                    </td>
                                    <td className={`${styles.stock} ${styles.tdBorder}`}>
                                        {product?.status ? (
                                            <>
                                                {product?.product?.inventory?.qtyAvailable}
                                                <div className={styles.dataMargin}>
                                                    {product?.product?.inventory?.qtyAvailable > 0
                                                        ? 'in stock'
                                                        : 'out of stock'}
                                                </div>
                                                {product?.product?.inventory?.factoryStock && (
                                                    <>
                                                        {product?.product?.inventory?.factoryStock}
                                                        <div className={styles.dataMargin}>factoryStock</div>
                                                    </>
                                                )}
                                                <div>
                                                    CanShip Immediately:{' '}
                                                    {product?.product?.inventory?.canShipImmediately ? 'YES' : 'NO'}
                                                </div>
                                            </>
                                        ) : (
                                            <div style={unmatchedTextStyle}>-</div>
                                        )}
                                    </td>
                                    <td className={`${styles.unitPrice} ${styles.tdBorder}`}>
                                        {product?.status ?
                                            <>
                                                {product?.product?.quantityTable
                                                    ?.slice(
                                                        0,
                                                        expandedProducts[product?.product?._id]
                                                            ? product?.product?.quantityTable?.length
                                                            : 2
                                                    )
                                                    .map((i, index) => (
                                                        <div key={index} className={styles.dataMargin}>
                                                            {i?.breakQty}: ₹{i?.unitPrice} {i?.packaging}
                                                        </div>
                                                    ))}
                                                {product?.product?.quantityTable?.length > 2 && (
                                                    <a
                                                        href="#"
                                                        onClick={(e) => {
                                                            e.preventDefault(); // Prevent page reload
                                                            toggleShowAll(product?.product?._id);
                                                        }}
                                                    >
                                                        <div className={styles.dataColorChange}>
                                                            {expandedProducts[product?.product?._id]
                                                                ? "Show Less"
                                                                : "More Inventory"}
                                                        </div>
                                                    </a>
                                                )}
                                            </>
                                            :
                                            <div style={unmatchedTextStyle}>-</div>
                                        }
                                    </td>
                                    <td className={`${styles.requiredQuantity} ${styles.tdBorder}`}>
                                        {product?.status ? (
                                            <>
                                                <input
                                                    type="text"
                                                    placeholder="Enter qty"
                                                    className={styles.dataInput}
                                                    value={product?.quantity}
                                                />
                                                {/* <div className={styles.dataMargin}>Min 1</div> */}
                                                {/* <div className={styles.dataCol}>
                                                    <button className={styles.addButton}>+ Add to cart</button>
                                                    <button className={styles.scheduleButton}>
                                                        + Add to schedule
                                                    </button>
                                                </div> */}
                                            </>
                                        ) : (
                                            <>
                                                <input
                                                    type="text"
                                                    className={styles.dataInput}
                                                    disabled
                                                    style={{ background: 'white' }}
                                                    value={product?.quantity}
                                                />
                                                <div style={unmatchedTextStyle}>-</div>
                                            </>
                                        )}
                                    </td>
                                    {
                                        enquiryType == "WIZARD" &&
                                        <td className={`${styles.requiredQuantity} ${styles.tdBorder}`}>
                                        </td>
                                    }
                                    {
                                        enquiryType === "excess" && <>
                                            <td className={`${styles.unitPrice} ${styles.tdBorder}`}>
                                                {
                                                    product?.targetPrice || "NA"
                                                }
                                            </td>
                                            <td className={`${styles.unitPrice} ${styles.tdBorder}`}>
                                                {
                                                    formateDate(product?.requiredDate)
                                                }
                                            </td>
                                        </>
                                    }
                                    {/* {allAttributeKeys.map((key) => (
                                        <td key={key} className={`${styles.packageType} ${styles.tdBorder}`}>
                                            {product?.product?.attributes[key]?.join(', ') || (
                                                <div style={unmatchedTextStyle}>-</div>
                                            )}
                                        </td>
                                    ))}
                                    {allEnvironmentalKeys.map((key) => (
                                        <td key={key} className={`${styles.packageType} ${styles.tdBorder}`}>
                                            {product?.product?.environmental[key]?.join(', ') || (
                                                <div style={unmatchedTextStyle}>-</div>
                                            )}
                                        </td>
                                    ))}
                                    {allAdditionalResources.map((key) => (
                                        <td key={key} className={`${styles.packageType} ${styles.tdBorder}`}>
                                            {product?.product?.additionalResources[key]?.join(', ') || (
                                                <div style={unmatchedTextStyle}>-</div>
                                            )}
                                        </td>
                                    ))} */}
                                </tr>

                                {product?.productNumber == productnumber &&
                                    <>
                                        {altProd?.length > 0 ?
                                            <>
                                                <div>
                                                    My Alternate
                                                </div>
                                                {altProd?.map((altpro, index) => (
                                                    <>
                                                        <tr style={{ marginTop: 10, display: 'flex', width: '100%' }}>

                                                            <div
                                                                key={altpro.productNumber}
                                                                style={{ textDecoration: 'underline', color: '#512DA8', cursor: 'pointer' }}
                                                                onClick={() => handleSelectAlternate(product?.productNumber, altpro?.productOverview?.productNumber[0])}
                                                            >
                                                                Replace Primary
                                                            </div>
                                                            <div onClick={() => dispatch(deleteAlterProduct(altpro?.productOverview?.productNumber[0]))} style={{ cursor: 'pointer' }}>
                                                                {trash()}
                                                            </div>
                                                        </tr>
                                                        <tr key={index} >
                                                            <td className={`${styles.compare}  `} style={{ border: 'none' }}></td>
                                                            <td className={`${styles.dataSheet} `}>

                                                                <div className={styles.dataCol}>
                                                                    <Pdf />
                                                                    <Leaf />
                                                                </div>

                                                            </td>
                                                            <td className={`${styles.partNumber} `}>

                                                                <div className={styles.dataRow}>

                                                                    <img src={altpro?.assets?.featuredImage[0]} style={{ width: 40, height: 40 }} />
                                                                    <div className={styles.dataCol}>
                                                                        <div className={styles.displayFlex}>
                                                                            <div className={styles.dataColorChange} onClick={() => navigate(`/productCode/${altpro?.product?._id}`)} style={{ cursor: 'pointer' }}>{altpro?.productOverview?.productNumber[0]}</div>
                                                                            <EditPart />
                                                                        </div>
                                                                        <div>{stripHtmlTags(altpro?.productOverview?.description?.[0] || altpro?.description)}</div>

                                                                    </div>

                                                                </div>
                                                            </td>
                                                            <td className={`${styles.manufacturer}`}>

                                                                <a href={product.manufacturerUrl} className={styles.manufacturer}>
                                                                    <div className={styles.dataColorChange}> {altpro?.productOverview?.manufacturer[0]?.name}</div>
                                                                </a>

                                                            </td>



                                                            <td className={`${styles.stock}`}>
                                                                <>
                                                                    {altpro?.product?.inventory?.qtyAvailable}
                                                                    <div className={styles.dataMargin}>{altpro?.product?.inventory?.qtyAvailable > 0 ? "in stock" : "out of stock"}</div>
                                                                    {altpro?.product?.inventory?.factoryStock ?
                                                                        <>
                                                                            {altpro?.product?.inventory?.factoryStock}
                                                                            <div className={styles.dataMargin}>factoryStock</div>
                                                                        </>
                                                                        : null}
                                                                    <div>CanShip Immediately: {altpro?.product?.inventory?.canShipImmediately ? 'YES' : 'NO'}</div>
                                                                </>

                                                            </td>
                                                            <td className={`${styles.unitPrice} `}>
                                                                <>
                                                                    {altpro?.product?.quantityTable
                                                                        ?.slice(
                                                                            0,
                                                                            expandedProducts[product?.product?._id]
                                                                                ? product?.product?.quantityTable?.length
                                                                                : 2
                                                                        )
                                                                        .map((i, index) => (
                                                                            <div key={index} className={styles.dataMargin}>
                                                                                {i?.breakQty}: ₹{i?.unitPrice} {i?.packaging}
                                                                            </div>
                                                                        ))}
                                                                    {altpro?.product?.quantityTable?.length > 2 && (
                                                                        <a
                                                                            href="#"
                                                                            onClick={(e) => {
                                                                                e.preventDefault(); // Prevent page reload
                                                                                toggleShowAll(product?.product?._id);
                                                                            }}
                                                                        >
                                                                            <div className={styles.dataColorChange}>
                                                                                {expandedProducts[product?.product?._id]
                                                                                    ? "Show Less"
                                                                                    : "More Inventory"}
                                                                            </div>
                                                                        </a>
                                                                    )}
                                                                </>

                                                            </td>

                                                            {altallAttributeKeys?.map((key) => (
                                                                <td key={key} className={`${styles.packageType} `}>
                                                                    {altpro?.attributes[key]?.join(", ") || <div style={{ color: 'white' }}>-</div>}
                                                                </td>
                                                            ))}
                                                            {altallEnvironmentalKeys?.map((key) => (
                                                                <td key={key} className={`${styles.packageType}  `}>
                                                                    {altpro?.environmental[key]?.join(", ") || <div style={{ color: 'white' }}>-</div>}
                                                                </td>
                                                            ))}

                                                            {altallAdditionalResources?.map((key) => (
                                                                <td key={key} className={`${styles.packageType} `}>
                                                                    {altpro?.additionalResources[key]?.join(", ") || <div style={{ color: 'white' }}>-</div>}
                                                                </td>
                                                            ))}
                                                        </tr>
                                                    </>
                                                ))
                                                }
                                            </>
                                            :
                                            <tr>
                                                No alter Products found
                                            </tr>
                                        }
                                    </>
                                }
                            </>
                        ))}
                    </tbody>
                </table>


                {/* <div style={{ width: '40%' }}>
                        <table className={styles.productTable}>
                            <thead className={styles.productTableHead}>
                                <tr>
                                    <th className={styles.compare}>Quote price</th>
                                    <th className={styles.dataSheet}>MOQ</th>
                                    <th className={styles.partNumber}></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td className={`${styles.requiredQuantity} ${styles.tdBorder}`}>
                                        <input
                                            type="text"
                                            placeholder="Enter "
                                            className={styles.dataInput}
                                        />
                                    </td>
                                    <td className={`${styles.requiredQuantity} ${styles.tdBorder}`}>
                                        <input
                                            type="text"
                                            placeholder="Enter "
                                            className={styles.dataInput}
                                        />
                                    </td>
                                    <td className={styles.previewtd} style={{ borderRight: '1px solid #0000001A', width: '11%' }}>
                                        <div style={{ display: "flex", gap: "20px", padding: '0px 20px' }}>
                                            <Refresh /> <Close />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div> */}
            </div>
        </div>

    );
};

export default BomListTable;
